import styled from "styled-components"
import { theme } from "../mixin"

export const Wrapper = styled.div`
  position: relative;

  overflow: hidden;
  padding: ${({ start }) => (start ? "80px 60px 60px 60px" : "60px")};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ bg }) => bg};
  @media (${theme.md}) {
    padding: ${({ start }) =>
      start ? "60px 20px 20px 20px" : "60px 20px 60px 20px"};
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 24px;
  position: relative;
  justify-content: ${({ center }) => (center ? "center" : "start")};
  align-items: center;
  @media (${theme.md}) {
    width: 100%;
    max-width: 300px;
    flex-direction: column;
    gap: 12px;
    a {
      width: 100%;
    }
  }
`

export const BGWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0;
  height: calc(100% - 0px);
  z-index: 0;
  /* overflow: hidden; */
`
// 文字相關
export const TextRow = styled.div`
  display: flex;
  position: relative;
  flex-wrap: wrap;
  justify-content: ${({ center }) => (center ? "center" : "start")};
  @media (${theme.md}) {
    width: 100%;
    flex-direction: column;
    align-items: ${({ center }) => (center ? "center" : "start")};
  }
`
export const DescWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media (${theme.md}) {
    gap: 0px;
    width: 100%;
    max-width: 400px;
    align-items: start;
  }
  @media (${theme.sm}) {
    gap: 12px;
    max-width: 300px;
  }
`
export const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 8px;
  align-items: center;
`

export const H1 = styled.h1`
  font-family: ${theme.titleFonts};
  font-weight: 700;
  line-height: 1.2;
  color: ${({ color }) => (color ? color : theme.secondary)};
  font-size: 64px;
  margin: 0;

  & span {
    background: ${theme.CTAcolorLinear};
    -webkit-background-clip: text;
    display: inline-block;
    -webkit-text-fill-color: transparent;
  }
  @media (${theme.xxl}) {
    font-size: 48px;
  }
  @media (${theme.lg}) {
    font-size: 28px;
  }
  @media (${theme.md}) {
    font-size: 28px;
  }
`
export const H2 = styled.h2`
  font-family: ${theme.titleFonts};
  font-weight: 700;
  line-height: 1.2;
  color: ${({ color }) => (color ? color : theme.secondary)};
  font-size: 64px;
  margin: 0;

  & span {
    background: ${theme.CTAcolorLinear};
    -webkit-background-clip: text;
    display: inline-block;
    -webkit-text-fill-color: transparent;
  }
  @media (${theme.xxl}) {
    font-size: 48px;
  }
  @media (${theme.lg}) {
    font-size: 28px;
  }
  @media (${theme.md}) {
    font-size: 28px;
  }
`

export const H3 = styled.h3`
  font-family: ${theme.titleFonts};
  color: ${({ color }) => (color ? color : theme.secondary)};
  font-weight: 700;
  line-height: 1.2;
  font-size: 36px;
  margin: 0;
  @media (${theme.xxl}) {
    font-size: 24px;
  }

  @media (${theme.lg}) {
    font-size: 20px;
  }
  @media (${theme.md}) {
    font-size: 20px;
  }
`
export const H4 = styled.h4`
  font-family: ${theme.titleFonts};
  color: ${({ color }) => (color ? color : theme.secondary)};
  font-weight: 700;
  line-height: 1.2;
  font-size: 24px;
  margin: 0;
  @media (${theme.xxl}) {
    font-size: 20px;
  }

  @media (${theme.lg}) {
    font-size: 18px;
  }
  @media (${theme.md}) {
    font-size: 16px;
    text-align: center;
  }
`

export const P = styled.p`
  color: ${theme.secondary};
`
export const StrongT = styled.p`
  color: ${theme.secondary};
  font-family: ${theme.titleFonts};
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  white-space: ${({ nowrap }) => (nowrap ? "nowrap" : "wrap")};
`
export const H5 = styled(StrongT)`
  font-size: 20px;
  @media (${theme.md}) {
    font-size: 16px;
  }
`

export const A = styled.h3``

export default Wrapper
